<template>
  <div class="tarja-wrapper-twitter" :style="wrapperStyles">
    <!-- Decorative Goticulas -->
    <img
        src="@/assets/AngelicaAoVivo/Tarjas/goticula-verde.png"
        alt=""
        class="goticula goticula-verde"
    />
    <img
        src="@/assets/AngelicaAoVivo/Tarjas/goticula-marfim.png"
        alt=""
        class="goticula goticula-marfim"
    />
    <img
        src="@/assets/AngelicaAoVivo/Tarjas/goticula-rosa.png"
        alt=""
        class="goticula goticula-rosa"
    />
    <img
        src="@/assets/AngelicaAoVivo/Tarjas/goticula-marrom.png"
        alt=""
        class="goticula goticula-marrom"
    />

    <div
        class="d-flex flex-column card mb-10"
        :style="cardStyles"
        :key="item.id_colaboracao"
    >
      <div class="content-wrapper">
        <!-- Header -->
        <header class="d-flex pb-1 pt-8" :style="headerStyles">
          <!-- Left side content (username) -->
          <div class="d-flex align-center">
            <!-- Username -->
            <span
                class="font-weight-medium"
                :class="usernameTextClass"
                :style="usernameStyles"
            >
            {{ displayName }}
          </span>
            <span
                v-if="item.dsc_colaborador_user"
                class="font-weight-black ml-2"
                :style="userHandleStyles"
            >
            {{ item.dsc_colaborador_user }}
          </span>
          </div>
        </header>

        <!-- Content Section -->
        <section class="text-section" :class="{ 'text-section-centered': shouldCenterContent }">
          <!-- Text Content -->
          <div
              v-if="isTextContent"
              v-html="colabText"
              class="font-weight-light"
              :class="{ 'text-centered-content': shouldCenterContent }"
              :style="textContentStyles"
          />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { apiClient } from "@/services/api";
import { formatTarjaText } from "@/utils/stringUtils";

export default {
  props: {
    item: Object,
    posicaoCard: String,
    flg_exibir_uf: Boolean,
  },

  data() {
    const angelicaAoVivoTheme = {
      colors: {
        username: "rgb(0,92,67)",
        userHandle: "rgba(0,92,67,1)",
        bodyText: "rgb(0,0,0)",
        hashtagColor: "rgb(147, 38, 17)",
        cardBgDefault: "rgb(232,230,225)",
        headerBgDefault: "rgb(232,230,225)",
        cardBorder: "#E5E5E5",
      },
      layout: {
        headerJustification: "space-between",
        cardWidth: "765px",
        cardHeight: "198px",
        cardBorderRadius: "45px",
        headerBorderRadius: "45px 45px 0 0",
        headerPaddingLeft: "90px",
        contentPaddingLeft: "90px",
        contentPaddingRight: "31px",
      },
      typography: {
        usernameFontFamily: "MozaicGeo Black",
        userHandleFontFamily: "MozaicGeo Bold",
        bodyFontFamily: "MozaicGeo Medium",
        usernameSize: "text-h5",
        userHandleSize: "1.12rem",
        textTransform: "lowercase",
      },
    };

    return {
      dsc_telefone_producao: null,
      hashtagGapPx: 80,

      platformThemes: {
        twitter: { ...angelicaAoVivoTheme },
        threads: { ...angelicaAoVivoTheme },
        bluesky: { ...angelicaAoVivoTheme },
        instagram: { ...angelicaAoVivoTheme },
        tiktok: { ...angelicaAoVivoTheme },
        whatsapp: { ...angelicaAoVivoTheme },
      },
    };
  },

  async created() {
    await this.getNumTelefoneProducao();
  },

  computed: {
    platformType() {
      const source = this.item.dsc_fonte_colaboracao?.toLowerCase();
      const platformMap = {
        twitter: "twitter",
        threads: "threads",
        bluesky: "bluesky",
        instagram: "instagram",
        tiktok: "tiktok",
        whatsapp: "whatsapp",
      };
      return platformMap[source] || "twitter";
    },

    currentTheme() {
      return this.platformThemes[this.platformType] || this.platformThemes.twitter;
    },

    isTextContent() {
      return !this.item.dsc_tipo_midia_colaboracao;
    },

    displayName() {
      if (this.flg_exibir_uf && this.item.dsc_uf_colaborador) {
        return `${this.item.dsc_nome_colaborador} - ${this.item.dsc_uf_colaborador}`;
      }
      return this.item.dsc_nome_colaborador;
    },

    bodyTextSize() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const sizeMap = {
        40: "1.8rem",
        80: "1.7rem",
        120: "1.6rem",
        160: "1.5rem",
        200: "1.4rem",
        240: "1.3rem",
        280: "1.2rem",
      };

      for (const [threshold, size] of Object.entries(sizeMap)) {
        if (numChars <= threshold) return size;
      }
      return "1.35rem";
    },

    lineHeight() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const lineHeightMap = {
        40: "2.1rem",
        80: "2.0rem",
        120: "1.9rem",
        160: "1.8rem",
        200: "1.7rem",
        240: "1.6rem",
        280: "1.5rem",
      };

      for (const [threshold, height] of Object.entries(lineHeightMap)) {
        if (numChars <= threshold) return height;
      }
      return "1.35rem";
    },

    colabText() {
      return formatTarjaText(this.item.dsc_texto_colaboracao, "angelicaaovivo");
    },

    headerStyles() {
      return {
        backgroundColor: this.currentTheme.colors.headerBgDefault,
        borderRadius: this.currentTheme.layout.headerBorderRadius,
        paddingLeft: this.currentTheme.layout.headerPaddingLeft,
      };
    },

    usernameTextClass() {
      return this.currentTheme.typography.usernameSize;
    },

    usernameStyles() {
      return {
        color: this.currentTheme.colors.username,
        fontFamily: `${this.currentTheme.typography.usernameFontFamily} !important`,
        textTransform: this.currentTheme.typography.textTransform,
      };
    },

    userHandleStyles() {
      return {
        color: this.currentTheme.colors.userHandle,
        fontFamily: `${this.currentTheme.typography.userHandleFontFamily} !important`,
        fontSize: this.currentTheme.typography.userHandleSize,
        opacity: 1,
      };
    },

    textContentStyles() {
      return {
        color: this.currentTheme.colors.bodyText,
        fontFamily: this.currentTheme.typography.bodyFontFamily,
        lineHeight: this.lineHeight,
        fontSize: this.bodyTextSize,
        paddingLeft: this.currentTheme.layout.contentPaddingLeft,
        paddingRight: this.currentTheme.layout.contentPaddingRight,
        "--hashtag-color": this.currentTheme.colors.hashtagColor,
      };
    },

    wrapperStyles() {
      const positionStyles = this.cardPositionStyles;
      return `${positionStyles}; position: relative; display: inline-block;`;
    },

    cardStyles() {
      return {
        backgroundColor: this.currentTheme.colors.cardBgDefault,
        width: this.currentTheme.layout.cardWidth,
        height: this.currentTheme.layout.cardHeight,
        border: `1px solid ${this.currentTheme.colors.cardBorder}`,
        borderRadius: this.currentTheme.layout.cardBorderRadius,
      };
    },

    cardPositionStyles() {
      const positionMap = {
        esquerda: !this.item.url_midia_colaboracao
            ? "margin-left: 90px; justify-self: flex-start"
            : "margin-left: 108px; justify-self: flex-start",
        centro: "justify-self: center",
        direita: !this.item.url_midia_colaboracao
            ? "margin-right: 36px; justify-self: flex-end"
            : "margin-right: 54px; justify-self: flex-start",
      };
      return positionMap[this.posicaoCard] || "";
    },

    shouldCenterContent() {
      const text = this.item.dsc_texto_colaboracao?.trim() || '';
      const numChars = text.length;

      // Center if text has 50 characters or less (roughly 1 line)
      return numChars <= 48;
    },
  },

  methods: {
    async getNumTelefoneProducao() {
      const cod_producao = localStorage.getItem("@socialcam/selected_option_production");
      try {
        const response = await apiClient.get(`/listarDadosProducao/${cod_producao}`);
        this.dsc_telefone_producao = response.data.producao.dsc_num_telefone;
      } catch (error) {
        console.error(error);
      }
    },
  },

  watch: {
    item: async function () {
      await this.getNumTelefoneProducao();
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "MozaicGeo Bold";
  src: url("@/assets/AngelicaAoVivo/fonts/MozaicGEO-Regular.otf") format("opentype");
}

@font-face {
  font-family: "MozaicGeo Medium";
  src: url("@/assets/AngelicaAoVivo/fonts/MozaicGEO-Medium.otf") format("opentype");
}

@font-face {
  font-family: "MozaicGeo Black";
  src: url("@/assets/AngelicaAoVivo/fonts/MozaicGEO-Black.otf") format("opentype");
}

.tarja-wrapper-twitter {
  position: relative;
  padding-bottom: 2vh;
}

.goticula {
  position: absolute;
  pointer-events: none;
}

.goticula-verde {
  top: -2%;
  left: -3%;
  width: 11%;
  height: auto;
  z-index: 10;
}

.goticula-marfim {
  top: -17%;
  right: -3%;
  width: 44%;
  height: auto;
  z-index: 1;
}

.goticula-rosa {
  bottom: 84%;
  right: 31%;
  width: 28%;
  height: auto;
  z-index: 2;
}

.goticula-marrom {
  bottom: 14%;
  left: 76%;
  width: 16%;
  height: auto;
  z-index: 5;
}

.card {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.text-section {
  display: flex;
}

.text-section-centered {
  position: relative;
}

.text-centered-content {
  position: relative;
  top: 70%;
}

.content-centered {
  justify-content: center;
}

.card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/AngelicaAoVivo/Tarjas/grain-texture.png');
  opacity: 0.12;
  pointer-events: none;
  border-radius: inherit;
  z-index: 1;
}

// Fix hashtag styling ONLY in text content area - be specific to avoid affecting header
section .font-weight-light ::v-deep span {
  color: var(--hashtag-color) !important;
  font-family: inherit !important;
  font-size: inherit !important;
  font-weight: inherit !important;
  line-height: inherit !important;
  text-transform: inherit !important;
}
</style>
